import { api } from '../lib/api';

export interface LikeResponse {
  liked: boolean;
  message: string;
}

/**
 * Toggle like on a post (like/unlike)
 */
export const toggleLike = async (postId: string): Promise<LikeResponse> => {
  const response = await api.post<LikeResponse>(`/posts/${postId}/likes`);
  return response.data;
};

/**
 * Check if current user has liked a post
 */
export const hasUserLiked = async (postId: string): Promise<boolean> => {
  const response = await api.get<{ hasLiked: boolean }>(
    `/posts/${postId}/likes/me`
  );
  return response.data.hasLiked;
};
